import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CalendarOptions } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { DatePipe } from '@angular/common';
import { TkAvailabilityService } from './tk-availability.service';
import { helperService } from 'src/app/utils/helper';
import { ProjectsGridService } from '../../projects-grid/projects-grid.service';
import { AuthGuard } from 'src/app/account/auth/app.gaurd';
import { UsersGridService } from '../../users-grid/users-grid.service';
import { forkJoin } from 'rxjs';


@Component({
    selector: 'app-tk-availability',
    templateUrl: './tk-availability.component.html',
    styleUrls: ['./tk-availability.component.scss'],
    standalone: false
})
export class TkAvailabilityComponent implements OnInit {
  // v13-migration placeholder (Ivy basic template-check requires the symbol to exist; undefined at runtime == v12 behaviour; Phase 2: align template)
  calendarEventRender: any;

  dialogFlag: boolean = false;
  mrgTimeDate: any;
  aftTimeDate: any;
  evnTimeDate: any;
  mrgTimeInvalid: Boolean = false;
  aftTimeInvalid: Boolean = false;
  evnTimeInvalid: Boolean = false;
  maxMorningHours:any;
  maxAfternoonHours:any;
  maxEveningHours:any;
  defaultTime:any;
  timeInvalid: Boolean = false;
  notAvailable: Boolean = false;
  btnLoading: Boolean = false;
  isLoading: Boolean = false;
  defaultDate:Date=new Date()
  today: any = "";
  start: any = "";
  end: any = "";
  events: any = [
  ]
  selectedDates:any;
  noDateRange:Boolean=false
  addTimeDialogue:Boolean=false;
  readonly dialogContentPadding: number = 32;
  pickerReserve: number = 32;
  activePickerPanel: HTMLElement | null = null;
  calendarOptions: CalendarOptions = {
    plugins: [dayGridPlugin, interactionPlugin],
    headerToolbar: {
      left: 'prevYear,prev',
      center: 'title',
      right: 'today,next,nextYear'
    },
    initialView: 'dayGridMonth',
    events: this.events,
    eventOrder: "order",
    eventClick:this.handleClick.bind(this),
    dateClick: this.handleClick.bind(this),
    datesSet: this.handleMonthChange.bind(this),
    contentHeight: "auto",
    // height:500,
    eventContent: this.customEventContent.bind(this),

  };
  title: string = "Add Time";
  selectedUserId:any="";
  loggedInUser:any;
  usersList:any[]=[];
  startDate:any;
  endDate:any;
  enableAddTime:boolean=false;
  isAdminUser:boolean=false;
  initialLoad:boolean=true;
  excludeSunday:boolean=true;
  excludeSaturday:boolean=true;
  saveError: string | null = null;

  constructor( 
    private userService : UsersGridService, private authService: AuthGuard,private projectService: ProjectsGridService,private datePipe: DatePipe, private availablityService: TkAvailabilityService, private filterService: helperService, private _cdr: ChangeDetectorRef) {
    this.defaultTime = new Date();
    this.defaultTime.setHours(0, 0, 0, 0);
    this.maxMorningHours = new Date();
    this.maxMorningHours.setHours(12, 0, 0, 0);
    this.maxAfternoonHours = new Date();
    this.maxAfternoonHours.setHours(5, 0, 0, 0);
    this.maxEveningHours = new Date();
    this.maxEveningHours.setHours(7, 0, 0, 0);
  }

  ngOnInit(): void {
    this.isLoading=true;
    if(this.filterService.isAdminUser(this.authService.roles)||this.filterService.isLPCUser(this.authService.roles)){
      this.isAdminUser=true;
      this.projectService.getLPCUsersList({
        "roles": ["LPC","TK","Approver"],
        "userTypes": []
      }).subscribe(res => {
        this.usersList = res.data;
      })
    }
   setTimeout(() => {
    this.userService.getLoginUser().subscribe({
      next: (res: any) => {
        this.selectedUserId = res.rows.id;
        this.loadAvailabilityList(this.startDate, this.endDate,this.selectedUserId);
        this.loggedInUser=res.rows;
        if(this.loggedInUser.id==this.selectedUserId){
          this.enableAddTime=true;
        }else{
          this.enableAddTime=false;
        }
      },
      error: () => {
        this.isLoading = false;
      }
    })
   }, 100);
  }

  async handleMonthChange(payload: any) {
    this.setCalendarOptions([]);
    let start = this.filterService.convertDateToFormattedStr(payload.view.activeStart)
    let end = this.filterService.convertDateToFormattedStr(payload.view.activeEnd)
    this.startDate=start;
    this.endDate=end;
    if(!this.initialLoad)
      this.loadAvailabilityList(start, end,this.selectedUserId);
    this.initialLoad=false;
    
  }

  handleClick(arg: any) {
    if(this.isAdminUser && this.loggedInUser.id!=this.selectedUserId)
      return;
    let date=arg.date?arg.date:arg.start;
    let dateString=arg.date?arg.dateStr:arg.startStr;
    
    if(date.getDate() < new Date().getDate() && date.getMonth() <= new Date().getMonth() && date.getFullYear() <= new Date().getFullYear())//skip all previous days 
        return;
    if(date.getMonth() < new Date().getMonth() && date.getFullYear() <= new Date().getFullYear())//skip all previous months
      return;
    if(date.getFullYear() < new Date().getFullYear())//skip all previous years
      return;
    this.today = dateString;
    let mrgTime = this.events.filter((obj: any) => obj.date == this.today && obj.title == "Morning").map((obj: any) => obj.availableTimeValue)[0]
      ? this.events.filter((obj: any) => obj.date == this.today && obj.title == "Morning").map((obj: any) => obj.availableTimeValue)[0] : 0;
    this.mrgTimeDate=this.filterService.convertTimeToDate(mrgTime);
    let aftTime = this.events.filter((obj: any) => obj.date == this.today && obj.title == "Afternoon").map((obj: any) => obj.availableTimeValue)[0]
      ? this.events.filter((obj: any) => obj.date == this.today && obj.title == "Afternoon").map((obj: any) => obj.availableTimeValue)[0] : 0
    this.aftTimeDate=this.filterService.convertTimeToDate(aftTime);
    let evnTime = this.events.filter((obj: any) => obj.date == this.today && obj.title == "Evening").map((obj: any) => obj.availableTimeValue)[0]
      ? this.events.filter((obj: any) => obj.date == this.today && obj.title == "Evening").map((obj: any) => obj.availableTimeValue)[0] : 0;
    this.evnTimeDate=this.filterService.convertTimeToDate(evnTime);
    this.notAvailable = this.events.find((obj: any) => obj.date == this.today && obj.title == "Not Available") ? true : false;
    this.title = "Edit Availability : " + this.datePipe.transform(dateString, "MM/dd/yyyy")
    this.dialogFlag = true;
  }
  getDaysArray = (start:any, end:any) =>{
    for(var arr=[],dt=new Date(start); dt<=new Date(end); dt.setDate(dt.getDate()+1)){
        arr.push(new Date(dt));
    }
    return arr;
  };

  get timeValidationError(): string | null {
    if (this.notAvailable) return null;
    const mrg = this.filterService.convertDateToTime(this.mrgTimeDate) || 0;
    const aft = this.filterService.convertDateToTime(this.aftTimeDate) || 0;
    const evn = this.filterService.convertDateToTime(this.evnTimeDate) || 0;
    if (mrg > 12 * 60) return 'Morning time should not exceed 12 hours.';
    if (aft > 5 * 60) return 'Afternoon time should not exceed 5 hours.';
    if (evn > 7 * 60) return 'Evening time should not exceed 7 hours.';
    if (mrg + aft + evn > 12 * 60) return 'Total time should not exceed 12 hours.';
    if (mrg + aft + evn === 0) return 'Enter at least one time (Morning, Afternoon, or Evening), or check "Not Available".';
    return null;
  }

  updateMultipleAvailable(){
    this.saveError = null;
    if(this.selectedDates && this.selectedDates.length && this.selectedDates[0] && this.selectedDates[1]){
      let dates=this.getDaysArray(this.selectedDates[0],this.selectedDates[1])
      if(this.excludeSaturday){
        dates=dates.filter((date:Date)=>!this.filterService.isSaturday(date))
      }
      if(this.excludeSunday){
        dates=dates.filter((date:Date)=>!this.filterService.isSunday(date))
      }
      if(!dates.length){
        this.saveError = 'No dates are available after applying weekend exclusions.';
        return;
      }
      const payloads = [];
      for (let date of dates) {
        const payload = this.buildAvailabilityPayload(date);
        if (payload === false) {
          return;
        }
        payloads.push(payload);
      }
      this.btnLoading = true;
      forkJoin(payloads.map(payload => this.availablityService.saveTask(payload))).subscribe({
        next: () => {
          this.loadAvailabilityList(this.start, this.end, this.selectedUserId);
          this.btnLoading = false;
          this.closeDialog();
        },
        error: (err: any) => {
          this.btnLoading = false;
          this.saveError = err?.error?.message || err?.message || 'Unable to save availability. Please try again.';
        }
      });
    }
    else{
      this.noDateRange=true;
      this.saveError = 'Please select a start and end date to proceed.';
    }
  }

  private buildAvailabilityPayload(currentDate:any): any | false {
    if(!currentDate){
      currentDate=this.today;
    }
    let mrgTime=this.filterService.convertDateToTime(this.mrgTimeDate);
    let aftTime=this.filterService.convertDateToTime(this.aftTimeDate);
    let evnTime=this.filterService.convertDateToTime(this.evnTimeDate);

    this.mrgTimeInvalid=mrgTime>12*60;
    this.aftTimeInvalid=aftTime>5*60;
    this.evnTimeInvalid=evnTime>7*60;

    let resultDate = this.datePipe.transform(currentDate, "MM/dd/yyyy");
    let payload = {
      morningSlot: 0,
      afternoonSlot: 0,
      eveningSlot: 0,
      availableDate: resultDate,
      away: "No",

    }

    if (this.notAvailable) {
      payload.away = "Yes";
    } else {
      if(this.mrgTimeInvalid||this.aftTimeInvalid||this.evnTimeInvalid){
        return false;
      }

      if (mrgTime + aftTime + evnTime > 12*60) {
        this.timeInvalid = true;
        return false;
      }
      if (mrgTime + aftTime + evnTime === 0) {
        this.saveError = 'Enter at least one time (Morning, Afternoon, or Evening), or check "Not Available".';
        return false;
      }
      if (mrgTime > 0) {
        payload.morningSlot = mrgTime;
      }
      if (aftTime > 0) {
        payload.afternoonSlot = aftTime;
      }
      if (evnTime > 0) {
        payload.eveningSlot = evnTime;
      }
    }

    return payload;
  }

  updateAvailable(currentDate:any):any {
    this.saveError = null;
    const payload = this.buildAvailabilityPayload(currentDate);
    if(payload === false){
      this.btnLoading = false;
      return false;
    }

    this.btnLoading = true;
    this.availablityService.saveTask(payload).subscribe({
      next: () => {
        this.loadAvailabilityList(this.start, this.end,this.selectedUserId);
        this.btnLoading = false;
        this.closeDialog()
      },
      error: (err: any) => {
        this.btnLoading = false;
        this.saveError = err?.error?.message || err?.message || 'Unable to save availability. Please try again.';
      }
    })
  }
  customEventContent(arg: any) {
    //add time
    let timeText = document.createElement('div')

    if (arg.event.extendedProps.availableTimeValue) {
      timeText.className = "fc-event-time";
      timeText.innerHTML = this.filterService.convertTimeNumToStr(arg.event.extendedProps.availableTimeValue);

    }
    //include additional info
    let additionalText = document.createElement('i')
    additionalText.className = "fc-event-title";
    additionalText.innerHTML = arg.event.title;

    let arrayOfDomNodes = [timeText, additionalText]
    return { domNodes: arrayOfDomNodes }
  }

  private toCalendarDate(value: any): any {
    if (!value || typeof value !== 'string') {
      return value;
    }
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
      const [month, day, year] = value.split('/');
      return `${year}-${month}-${day}`;
    }
    return value.substring(0, 10);
  }
  
  reservePickerSpace(event: any) {
    const panel: HTMLElement = event?.element;
    const dialogs = document.querySelectorAll<HTMLElement>('.p-dialog');
    const dialog: HTMLElement | null = dialogs.length ? dialogs[dialogs.length - 1] : null;
    if (!panel || !dialog) {
      return;
    }
    this.activePickerPanel = panel;
    const dialogTop = dialog.getBoundingClientRect().top;
    const overflow = (panel.getBoundingClientRect().top + panel.offsetHeight) - (dialogTop + dialog.offsetHeight);
    if (overflow <= 0) {
      return;
    }
    this.pickerReserve = this.pickerReserve + Math.ceil(overflow) + 8;
    this._cdr.detectChanges();
    const panelTop = parseFloat(panel.style.top);
    const recentered = dialog.getBoundingClientRect().top - dialogTop;
    if (!isNaN(panelTop) && recentered !== 0) {
      panel.style.top = (panelTop + recentered) + 'px';
    }
  }

  releasePickerSpace(event?: any) {
    const panel: HTMLElement = event?.element;
    if (panel && this.activePickerPanel && panel !== this.activePickerPanel) {
      return;
    }
    this.activePickerPanel = null;
    this.pickerReserve = this.dialogContentPadding;
  }

  closeDialog() {
    this.releasePickerSpace();
    this.dialogFlag = false;
    this.timeInvalid = false;
    this.notAvailable = false;
    this.addTimeDialogue=false;
    this.excludeSaturday=true;
    this.excludeSunday=true;
    this.selectedDates=null;
    this.noDateRange=false;
    this.mrgTimeDate=null;
    this.aftTimeDate=null;
    this.evnTimeDate=null;
    this.saveError=null;
  }

  loadAvailabilityList(start: any, end: any,userId:any) {
    this.start = start ? start : this.start;
    this.end = end ? end : this.end;
    this.isLoading = true;
    this.availablityService.getAllAvailabilityList(start, end,userId).subscribe({
      next: (res: any) => {
        let list: any = []
        const rows = res?.data ?? [];
        rows.forEach((element: any) => {
          const availableDate = this.toCalendarDate(element.availableDate);
          if (element.away == "Yes") {
            list.push({ title: "Not Available", date: availableDate, allDay: true, color: '#c97c7c', order: 5 })
          } else {
            if (element.morningSlot > 0) {
              list.push({ title: "Morning", date: availableDate, color: '#3d82b9', availableTimeValue: element.morningSlot, order: 1 });
            }
            if (element.afternoonSlot > 0) {
              list.push({ title: "Afternoon", date: availableDate, color: '#3d82b9', availableTimeValue: element.afternoonSlot, order: 2 });
            }
            if (element.eveningSlot > 0) {
              list.push({ title: "Evening", date: availableDate, color: '#3d82b9', availableTimeValue: element.eveningSlot, order: 3 })
            }
            if (element.morningSlot > 0 || element.afternoonSlot > 0 || element.eveningSlot > 0)
              list.push({ title: "Total Availability", date: availableDate, color: '#5c9f5c', availableTimeValue: Number(element.morningSlot) + Number(element.afternoonSlot) + Number(element.eveningSlot), order: 4 });

          }
        });
        this.events = list;
        this.setCalendarOptions(list);
        this.isLoading = false;
      },
      error: () => {
        this.events = [];
        this.setCalendarOptions([]);
        this.isLoading = false;
      }
    })
  }

  addTime(){
    this.addTimeDialogue=true;
  }

  setCalendarOptions(list: any) {
    this.calendarOptions.events = [];
    const that=this;
    this.calendarOptions = {
      plugins: [dayGridPlugin, interactionPlugin],
      headerToolbar: {
        left: 'prevYear,prev',
        center: 'title',
        right: 'today,next,nextYear'
      },
      initialView: 'dayGridMonth',
      events: list,
      eventOrder: "order",
      contentHeight: "auto",
      eventClick: function(info) {
        console.log(info.event.start);
        that.handleClick(info.event);
      },
      dateClick: this.handleClick.bind(this),
      datesSet: this.handleMonthChange.bind(this),
      // height:500,
      eventContent: this.customEventContent.bind(this),
    };
    
  }
  onUserChange(){
    if(this.loggedInUser.id==this.selectedUserId){
      this.enableAddTime=true;
    }else{
      this.enableAddTime=false;
    }
    this.loadAvailabilityList(this.startDate, this.endDate,this.selectedUserId);
  }
}
